require('./retailLoanSidebar.scss');
require('./retailLoanSidebar.override.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { isEqual } = require('lodash/lang');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const { RetailLoanCatalogModal } = require('../retailLoanCatalogModal/retailLoanCatalogModal');
const RetailLoanFullImageModal = require('../retailLoanFullImageModal/retailLoanFullImageModal');
const RetailLoanPickupAddress = require('../../contractRetailLoan/retailLoanPickupAddress/retailLoanPickupAddress');

// @utilities
const { getFormattedString } = require('utilities/currencyHelper');
const { buildLoadStepRetailLoanInfo, getMaskedAccount, isRetailAddressDelivery } = require('../../../../loansUtilities/loansHelper');
const DateHelper = require('utilities/dateHelper');

// @helpers
const { getPublicSitePath } = require('core/apiURLBuilder');
const { recordLinkV2, PROC_START, PROC_STEP } = require('utilities/tagging');

// @constants
const { EURO_TEXT } = require('constants/index');
const { configOkLoans, retailLoanDoTaggin } = require('../../../../loansConstants/index');
const placeHolder = require('../../../../assets/images/placeHolder.png');
const {
    ACTION_EVENT_VIEW,
    CHEVRON_CLOSE,
    OPEN_MARKET_PRODUCT_MODAL_EVENT_TAG,
    OPEN_MARKET_SEE_ACTION_DETAILS
} = require('constants/tagging');

class RetailLoanSidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showModalFullImagen: false
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleProductTitleClick = this.handleProductTitleClick.bind(this);
        this.handleToggleModalFullImage = this.handleToggleModalFullImage.bind(this);
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        }, () => {
            this.handleProductModalTaggings(this.state.showModal);
        });
    }

    handleProductModalTaggings(isProductModalOpen) {
        const { immRetailLoan } = this.props;
        const visibleStep = immRetailLoan.get('visibleStep');
        const customData = {
            categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
            accionEvento: OPEN_MARKET_PRODUCT_MODAL_EVENT_TAG,
            etiquetaEvento: isProductModalOpen ? ACTION_EVENT_VIEW : CHEVRON_CLOSE,
            pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
            ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
        };

        recordLinkV2(customData);
    }

    handleProductTitleClick(productTitle) {
        const { immRetailLoan } = this.props;
        if (productTitle) {
            const visibleStep = immRetailLoan.get('visibleStep');
            const customData = {
                categoriaEvento: retailLoanDoTaggin.NAME_PAGE_WIZARD_VIEW,
                accionEvento: `paso_${visibleStep}`,
                etiquetaEvento: `${OPEN_MARKET_SEE_ACTION_DETAILS} ${productTitle}`,
                pasoProceso: visibleStep === 1 ? PROC_START : PROC_STEP + visibleStep,
                ...buildLoadStepRetailLoanInfo(immRetailLoan, visibleStep),
            };

            recordLinkV2(customData);
        }
        this.handleToggleModal();
    }

    handleToggleModalFullImage() {
        this.setState({
            showModalFullImagen: !this.state.showModalFullImagen
        });
    }

    buildModal(item, currency) {
        const { immRetailLoan } = this.props;
        return (
            <RetailLoanCatalogModal
                showModal={this.state.showModal}
                onHandleToggleModal={this.handleToggleModal}
                labels={configOkLoans(formatText, item, currency)}
                item={item}
                immRetailLoan={immRetailLoan}
                termsAndConditionsUrl={getPublicSitePath('termsAndConditions')}
                hideActionSection
            />
        );
    }

    buildFullImageModal(url) {
        return (
            <RetailLoanFullImageModal
                urlImage={url}
                showModal={this.state.showModalFullImagen}
                onHandleToggleModal={this.handleToggleModalFullImage}
            />
        );
    }

    buildDeliveryDateSection(deliveryDate) {
        return (
            <OKInformativeList>
                <OKInformativeListItem
                    title="retailLoanSidebar-deliveryDate"
                    bodyText={deliveryDate}
                />
            </OKInformativeList>
        )
    }

    buildPickUpSection() {
        const { immRetailLoan } = this.props;
        const toBeDefinedText = formatText('retailLoanSidebar-toBeDefined');
        const immSelectedOffice = immRetailLoan.get('selectedPickup');
        const pickupAdress = (
            <RetailLoanPickupAddress
                immOffice={immSelectedOffice}
            />
        );
        const pickupText = immSelectedOffice ? pickupAdress : toBeDefinedText;
        return (
            <OKInformativeList>
                <OKInformativeListItem
                    title="retailLoanSidebar-pickUpAddress"
                    className="retail-loan-sidebar__pick-up-address"
                    children={pickupText}
                />
            </OKInformativeList>
        )
    }

    onLoadErrorImage(e) {
        e.target.src = placeHolder;
    }

    render() {
        const { immRetailLoan, immAccount } = this.props;

        const selectedItemId = immRetailLoan.get('purpose');
        const immProducts = immRetailLoan.get('products');
        const currency = immRetailLoan.get('currency');
        const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
        const modal = this.buildModal(immSelectedItem, currency);

        if (immSelectedItem) {
            const toBeDefinedText = formatText('retailLoanSidebar-toBeDefined');
            let decimalsLength = immSelectedItem.get('field_total_product_price') - Math.floor(immSelectedItem.get('field_total_product_price'));
            const amount = getFormattedString({
                amount: immSelectedItem.get('field_total_product_price'),
                currency: EURO_TEXT,
                decimalsLength: decimalsLength > 0 ? 2 : 0
            });

            const selectedTerm = immRetailLoan.get('selectedTerm');
            const term = selectedTerm ? formatText('retailLoanSidebar-termMonths', [selectedTerm]) : toBeDefinedText;

            const installmentAmount = immRetailLoan.getIn(['installment', 'amount']);
            const installmentRaw = immRetailLoan.get('installment');

            const payment = (installmentAmount !== '') ? getFormattedString(installmentRaw) : toBeDefinedText;
            const rawDeliveryDate = immSelectedItem.get('deliveryDate');
            const deliveryDate = DateHelper.formatDate(rawDeliveryDate);
            const rawProductTitle = immSelectedItem.get('title');
            const productTitle = rawProductTitle.toUpperCase();
            const productImageURI = immSelectedItem.getIn(['field_product_images', 0, 'url']);
            const urlImageProvider = immSelectedItem.get('field_retail_provider') ? immSelectedItem.get('field_retail_provider').get('image') : '';
            const provider = immSelectedItem.get('field_retail_provider') ? immSelectedItem.getIn(['field_retail_provider', 'provider']) : '';
            const fullImageModal = this.buildFullImageModal(productImageURI);
            const deliveryType = immSelectedItem.get('field_pickup_option');

            let associatedAccountInformationItem;

            if (this.props.displayAssociatedAccount && immAccount) {
                associatedAccountInformationItem = (
                    <OKInformativeListItem
                        title={formatText('payrollLoanCompilationCard-associatedAccount')}
                        bodyText={getMaskedAccount(immAccount)}
                    />
                );
            }
            const pickUpOrDeliverySection = isRetailAddressDelivery(deliveryType) ? this.buildDeliveryDateSection(deliveryDate) : this.buildPickUpSection();

            return (
                <div className="retail-loan-sidebar">
                    <header className="retail-loan-sidebar__header">
                        <FormattedText
                            value="retailLoanSidebar-title"
                            className="retail-loan-sidebar__title"
                        />
                        <div className="retail-loan-sidebar__commercialized-by">
                            <FormattedText
                                className="retail-loan-sidebar__provider"
                                value="retailLoanSidebar-commercializedBy"
                                injectedStrings={[provider]}
                            />
                            <div>
                                {!isEqual(urlImageProvider, '') &&
                                    <img
                                        className="retail-loan-catalog-item__logo-catalog-item"
                                        src={urlImageProvider}
                                        onError={(e) => this.onLoadErrorImage(e)}
                                    />
                                }
                            </div>
                        </div>
                    </header>
                    <div className="retail-loan-sidebar__image-container" >
                        <img
                            className="retail-loan-sidebar__image"
                            src={productImageURI}
                            onClick={this.handleToggleModalFullImage}
                            onError={(e) => this.onLoadErrorImage(e)}
                        />
                        <OKButton
                            modifier="link-complementary"
                            onClick={() => this.handleProductTitleClick(rawProductTitle)}
                        >
                            {productTitle}
                        </OKButton>
                    </div>
                    <div className="retail-loan-sidebar__informative-section">
                        <OKInformativeList>
                            <OKInformativeListItem
                                title="retailLoanSidebar-payment"
                                bodyText={payment}
                            />
                            <OKInformativeListItem
                                title="retailLoanSidebar-amount"
                                bodyText={amount}
                            />
                            <OKInformativeListItem
                                title="retailLoanSidebar-term"
                                bodyText={term}
                            />
                            {associatedAccountInformationItem}
                        </OKInformativeList>
                    </div>
                    <div className="retail-loan-sidebar__informative-section">
                        {pickUpOrDeliverySection}
                    </div>
                    {modal}
                    {fullImageModal}
                </div>
            );
        }
    }
}

RetailLoanSidebar.propTypes = {
    immAccount: PropTypes.object,
    immRetailLoan: PropTypes.object.isRequired,
    displayAssociatedAccount: PropTypes.bool
};

module.exports = RetailLoanSidebar;
